import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ContactPropertyOwner({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3 className="yellow-info-text">
              Make sure and share a link to the property inspection in google
              drive if applicable so that owner can see pics
            </h3>
          </Col>
          <Col span={24}>
            <h3>
              If the property owner does not reply to this email within 3 weeks
              notify the broker in charge and get their approval on any renewal
              offer.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="yellow-info-text">
              Please send this msg to the owner through appfolio
            </h3>
          </Col>
          <Col span={24}>
            <p>Good morning-</p>
            <p>
              The lease on your property at the above address will be expiring.
              We generally would suggest offering both of the following options
              to your tenant. Please review the details below and reply back to
              me with your decision in the next few days.{" "}
            </p>
            <ul>
              <li>
                <p>
                  {" "}
                  Option 1: 12 month renewal - $15 to $25 increase from current
                  rental rate.
                </p>
              </li>
              <li>
                <p>
                  {" "}
                  Option 2: Month to Month renewal - $100 per month fee added to
                  current rental rate.
                </p>
              </li>
            </ul>
          </Col>
          <Col span={24}>
            <p>
              If your home is has a section 8 tenant in place we will need to
              contact the section 8 office for that tenant to see if they
              approve the increase.
            </p>
          </Col>
          <Col span={24}>
            <p>
              If you would like to change these amounts or terms, please let us
              know and we will edit as needed.
            </p>
          </Col>
          <Col span={24}>
            <p>
              Do keep in mind as you look at a rental rate change that it is
              often helpful to offer an upgrade to the tenants of some sort on
              their unit. At times this can be something small and at times
              owners elect to do larger projects to protect and improve their
              property. Often most of these are looked at as a good thing by the
              tenant and helps to offset the increase for the tenant while
              improving your property at the same time.
            </p>
          </Col>
          <Col span={24}>
            <p>
              Once we hear back from you, We will make the offer to the tenant.
              If there is no response to our attempt their lease will go month
              to month at the higher rate. At that point your options will be to
              allow them to remain on a month to month lease or give them notice
              to vacate in 30 days and we can then list the home for rent again.
            </p>
          </Col>
          <Col span={24}>
            <p>
              Once the tenant accepts the new terms we will prepare a lease
              renewal agreement for signatures. After the agreement is signed we
              will update their ledger and add the new agreement to your owner
              portal.
            </p>
          </Col>
          <Col span={24}>
            <p>
              If we do not hear back from you before their lease expires, we
              will allow their lease to go month to month at the $50 extra per
              month rate.
            </p>
          </Col>
          <Col span={24}>
            <p>
              If you would like to look at potentially selling your property
              just let me know and I can help you get it listed for sale as
              well.
            </p>
          </Col>
          <Col span={24}>
            <p>If you have further questions please let us know.</p>
          </Col>
          <Col span={24}>
            <p>Thank you in advance for your prompt reply.</p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ContactPropertyOwner;
